import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { IoMdClose } from "react-icons/io";
import { BASE_URL } from "utils/constant";
import { useAlert } from "components/UI_components/Alert";

export default function AddVendor({ onClose }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [address, setAddress] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const { addAlert } = useAlert();

  const handleNumberInput = (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    e.target.value = onlyNums;
    setContactNumber(onlyNums);
    if (onlyNums.length > 0 && onlyNums.length < 10) {
      setPhoneError("Contact number must be exactly 10 digits");
    } else {
      setPhoneError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 10-digit validation before API call
    if (contactNumber.length !== 10) {
      setPhoneError("Contact number must be exactly 10 digits");
      return;
    }
    setPhoneError("");

    try {
      const accessToken = localStorage.getItem("access");
      const organisationId = JSON.parse(
        localStorage.getItem("organization"),
      ).id;
      const response = await fetch(`${BASE_URL}/inventory/create-vendor/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          name: name,
          vendor_type: type,
          address: address,
          contact_no: "+91" + contactNumber,
          organization: organisationId,
        }),
      });

      const data = await response.json();
      if (data.status) {
        console.log("Vendor created successfully:", data);
        onClose();
        addAlert("Vendor created successfully", "success");
      } else {
        console.error("Error creating vendor:", data.error);
        addAlert("Error creating vendor: " + data.error, "error");
      }
    } catch (error) {
      console.error("Error creating vendor:", error);
      addAlert("Error creating vendor: " + error.message, "error");
    }
  };

  return (
    <div className="fixed inset-0 bg-[black] bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-[15px] w-[40vw] relative">
        <div className="flex justify-between items-center mb-6 border-b-[0.5px] border-gray-300 py-3 px-6">
          <div></div>
          <div className="text-[#232323] text-lg font-medium">New Vendor</div>
          <button
            className="text-2xl font-semibold text-gray-500 hover:text-black"
            onClick={onClose}
          >
            <IoMdClose size={24} />
          </button>
        </div>

        <div className="text-[#232323] text-lg font-semibold mb-6 px-4">
          General Details
        </div>

        <div className="space-y-4 py-3 px-4">
          <div>
            <label className="block text-[#000000] text-[16px] mb-1">
              Vendor Name
            </label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
              className="w-full px-4 py-2 rounded-md bg-[#F5F5F5] outline-none"
            />
          </div>

          <div>
            <label className="block text-[#000000] text-[16px] mb-1">
              Select type
            </label>
            <input
              type="text"
              required
              value={type}
              onChange={(e) => setType(e.target.value)}
              placeholder="Enter Vendor type. (Eg. Brick supplier)"
              className="w-full px-4 py-2 rounded-md bg-[#F5F5F5] outline-none"
            />
            {/* Some predefined options */}
            <div className="mt-2 flex flex-wrap gap-2 px-2 py-1">
              {[
                "Cement Supplier",
                "Steel Supplier",
                "Brick Supplier",
                "Electricals",
                "Plumbing",
              ].map((option) => (
                <button
                  key={option}
                  onClick={() => setType(option)}
                  className={`px-3 py-1 rounded-full text-sm ${
                    type === option
                      ? "bg-[#ECE6F0] text-[#3B0069] border-[1px] border-[#3B0069]"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-[#000000] text-[16px] mb-1">
              Address
            </label>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
              placeholder="Enter Address. (Saltlake, Kolkata, 700000)"
              className="w-full px-4 py-2 rounded-md bg-[#F5F5F5] outline-none"
            />
          </div>

          <div>
            <label className="block text-[#000000] text-[16px] mb-1">
              Contact number
            </label>
            <div
              className={`flex items-center bg-[#F5F5F5] px-4 py-2 rounded-md border ${
                phoneError ? "border-red-500" : "border-transparent"
              }`}
            >
              <span className="mr-2">+91</span>
              <input
                type="text"
                maxLength={10}
                value={contactNumber}
                onInput={handleNumberInput}
                placeholder="9999999999"
                required
                className="w-full bg-transparent outline-none"
              />
            </div>
            {phoneError && (
              <p className="text-red-500 text-sm mt-1">{phoneError}</p>
            )}
          </div>
        </div>

        <div className="flex justify-center mt-6 p-3">
          <button
            onClick={handleSubmit}
            className="w-[200px] h-[50px] bg-[#3B0069] text-[18px] hover:bg-[#2a004c] text-white py-3 rounded-[10px] flex items-center justify-center gap-2"
          >
            Save
            <div className="w-8 h-8 rounded-full bg-[#5E2D91] flex items-center justify-center ml-2">
              <ArrowRight className="h-6 w-6 text-white" />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
